import { Injectable } from '@angular/core';
import { RelayService } from './relay.service';
import { UtilityService } from './utility.service';
import { PageRequest } from '../models/page-request';

@Injectable({
  providedIn: 'root'
})
export class StressService {

  constructor(
    private relayService: RelayService,
    private utilityService: UtilityService
  ) { }

  getRandomPage(pages: string[]) {
    const random = Math.floor(Math.random() * pages.length);

    if (pages.length == 0) {
      this.relayService.getDefaultPage();
    } else if (pages.length === 1) {
      const pageRequest: PageRequest = {} as PageRequest;
      pageRequest.pageId = pages[0];
      this.relayService.getPage(pageRequest);
    } else {
      const pageRequest: PageRequest = {} as PageRequest;
      pageRequest.pageId = pages[random];
      this.relayService.getPage(pageRequest);
    }
  }

  async logarithmic(x: number, pages: string[]) {
    console.log('logarithmic:', x);
    for (let i = 0; i < x; i++) {

      const requests = Math.log10(Math.pow(i, i));

      console.log(`Round: ${i}. ${requests} Requests`);
      for (let y = 0; y < requests; y++) {
        console.log(`Request: `, y);
        this.getRandomPage(pages);
        await this.utilityService.delay(100);
      }

      console.log(`Waiting: `, 2000);
      await this.utilityService.delay(2000);
    }
  }

  async modulus(x: number, pages: string[]) {
    console.log('logarithmic:', x);
    for (let i = 0; i < x; i++) {

      const requests = i % 5;

      console.log(`Round: ${i}. ${requests} Requests`);
      for (let y = 0; y < requests; y++) {
        console.log(`Request: `, y);
        this.getRandomPage(pages);
        await this.utilityService.delay(100);
      }

      console.log(`Waiting: `, 2000);
      await this.utilityService.delay(2000);
    }
  }

  async exponential(x: number, pages: string[]) {
    for (let i = 0; i < x; i++) {

      const requests = Math.pow(i, i);

      console.log(`Round: ${i}. ${requests} Requests`);
      for (let y = 0; y < requests; y++) {
        console.log(`Request: `, y);
        this.getRandomPage(pages);
        await this.utilityService.delay(100);
      }

      console.log(`Waiting: `, 2000);
      await this.utilityService.delay(2000);
    }
  }

  async linear(x: number, pages: string[]) {
    for (let i = 0; i < x; i++) {

      const requests = i;

      console.log(`Round: ${i}. ${requests} Requests`);
      for (let y = 0; y < requests; y++) {
        console.log(`Request: `, y);
        this.getRandomPage(pages);
        await this.utilityService.delay(100);
      }

      console.log(`Waiting: `, 2000);
      await this.utilityService.delay(2000);
    }
  }

  async random(x: number, pages: string[]) {
    for (let i = 0; i < x; i++) {

      const requests = Math.floor(Math.random() * x);

      console.log(`Round: ${i}. ${requests} Requests`);
      for (let y = 0; y < requests; y++) {
        console.log(`Request: `, y);
        this.getRandomPage(pages);
        await this.utilityService.delay(100);
      }

      console.log(`Waiting: `, 2000);
      await this.utilityService.delay(2000);
    }
  }
}
